module.exports = __webpack_public_path__ + "media/images/icon__locked@2x-807df8a82c281bc7d572ec5cff60024a.png";